module.exports = __webpack_public_path__ + "static/media/alphaTetris-preview.4017c001.png";